var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_321_14812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.86646 4.64355L2.56639 13.2511C2.61655 13.8718 3.13558 14.3585 3.74723 14.3585H10.1964C10.808 14.3585 11.3271 13.8718 11.3772 13.2511L12.0771 4.64355H1.86646ZM4.99562 12.7483C4.78877 12.7483 4.61474 12.5844 4.60162 12.3709L4.20646 5.87636C4.19295 5.65426 4.35849 5.46321 4.57615 5.44944C4.80189 5.43331 4.98134 5.60394 4.99523 5.82604L5.39039 12.3206C5.40438 12.5505 5.22574 12.7483 4.99562 12.7483ZM7.36695 12.3457C7.36695 12.5682 7.19021 12.7483 6.97179 12.7483C6.75337 12.7483 6.57663 12.5682 6.57663 12.3457V5.85121C6.57663 5.62871 6.75337 5.44866 6.97179 5.44866C7.19021 5.44866 7.36695 5.62871 7.36695 5.85121V12.3457ZM9.73712 5.87639L9.34196 12.3709C9.32898 12.5822 9.15608 12.7583 8.92288 12.7475C8.70523 12.7337 8.53968 12.5427 8.5532 12.3206L8.94836 5.82607C8.96187 5.60396 9.15289 5.44238 9.36744 5.44946C9.58509 5.46323 9.75064 5.65428 9.73712 5.87639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1089 2.22837H9.73796V1.82582C9.73796 1.15989 9.20618 0.618164 8.55248 0.618164H5.3912C4.7375 0.618164 4.20572 1.15989 4.20572 1.82582V2.22837H1.83475C1.39826 2.22837 1.04443 2.58882 1.04443 3.03348C1.04443 3.47808 1.39826 3.83858 1.83475 3.83858C5.46933 3.83858 8.47447 3.83858 12.1089 3.83858C12.5454 3.83858 12.8992 3.47808 12.8992 3.03348C12.8992 2.58882 12.5454 2.22837 12.1089 2.22837ZM8.94764 2.22837H4.99604V1.82582C4.99604 1.60372 5.17317 1.42327 5.3912 1.42327H8.55248C8.7705 1.42327 8.94764 1.60372 8.94764 1.82582V2.22837Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_321_14812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.4881,
    height: 13.7405,
    fill: "white",
    transform: "translate(0.227783 0.618164)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.fb1b41258405e632591461709909f041.svg";
export { ForwardRef as ReactComponent };